import { cfAPI } from "../api";
import { createRequestHandler } from "../utils/requestHandlers";

// Action Types
export const FAQ_REQUEST = "FAQ_REQUEST";
export const FAQ_ERROR = "FAQ_ERROR";
export const FAQ_FETCH = "FAQ_FETCH";
export const FAQ_FETCHES = "FAQ_FETCHES";
export const FAQ_CREATE = "FAQ_CREATE";
export const FAQ_EDIT = "FAQ_EDIT";
export const FAQ_DELETE = "FAQ_DELETE";

const BaseRoute = "companyapi/api/v1/faqs";

// Reusable action types object for consistency
const actionTypes = {
  fetches: { request: FAQ_REQUEST, success: FAQ_FETCHES, error: FAQ_ERROR },
  fetch: { request: FAQ_REQUEST, success: FAQ_FETCH, error: FAQ_ERROR },
  create: { request: FAQ_REQUEST, success: FAQ_CREATE, error: FAQ_ERROR },
  update: { request: FAQ_REQUEST, success: FAQ_EDIT, error: FAQ_ERROR },
  delete: { request: FAQ_REQUEST, success: FAQ_DELETE, error: FAQ_ERROR },
};

const INITIAL_STATE = {
  loading: false,
  faqs: [],
  faq: {},
  error: "",
};

// Actions using the new handlers
export const FetchFAQS = () => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.get(BaseRoute),
    actionTypes.fetches,
    null // No toast for a fetch
  );
};

export const FetchFAQ = (id) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.get(`${BaseRoute}/${id}`),
    actionTypes.fetch,
    null // No toast for a fetch
  );
};

export const CreateFAQ = (values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.post(BaseRoute, values),
    actionTypes.create,
    "FAQ Created"
  );
};

export const UpdateFAQ = (id, values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.patch(`${BaseRoute}/${id}`, values),
    actionTypes.update,
    "FAQ Updated"
  );
};

export const DeleteFAQ = (id, values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.delete(`${BaseRoute}/${values.id}`),
    actionTypes.delete,
    "FAQ Deleted"
  );
};

// Reducer with toasts removed and state logic updated
export const FAQReducers = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FAQ_REQUEST:
      return { ...state, loading: true };
    case FAQ_FETCHES:
      return { ...state, loading: false, faqs: action.payload };
    case FAQ_FETCH:
      return { ...state, loading: false, faq: action.payload };
    case FAQ_CREATE:
      return {
        ...state,
        loading: false,
        faqs: [...state.faqs, action.payload],
      };
    case FAQ_EDIT:
      const updatedList = state.faqs.map((faq) =>
        faq.id === action.payload.id ? action.payload : faq
      );
      return {
        ...state,
        loading: false,
        faq: action.payload,
        faqs: updatedList,
      };
    case FAQ_DELETE:
      const filteredList = state.faqs.filter(
        (faq) => faq.id !== action.payload.id
      );
      return { ...state, loading: false, faqs: filteredList };
    case FAQ_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
